module.exports = __webpack_public_path__ + "img/introduce-icon2.6bc64b01.svg";